import React from 'react';
import {
  Row,
  Col,
  Card,
  CardImg,
  CardText,
  CardBody,
  CardTitle,
  Button,
  Container,
} from 'reactstrap';
import { IsEmpty, Map } from 'react-lodash';

const HomeBlogs = () => {
  const BlogData = [
    {
      name: '10 Important Topics of JavaScript that you can’t ignore',
      Photo: 'https://i.ibb.co/R6jB38Z/js.png',
      link:
        'https://azimuahamed.medium.com/10-important-topics-of-javascript-that-you-cant-ignore-6c42428b1b5a',
      description:
        'why are you still stuck into the caption ? Don’t you believe this caption? Ok…. let’s start about our 10 selected topics .',
      id: '',
    },
    {
      name: 'Why You Should Learn React Instead Of Learning Other Framework .',
      Photo: 'https://i.ibb.co/W0S8z8r/react.png',
      link:
        'https://azimuahamed.medium.com/why-you-should-learn-react-instead-of-learning-other-framework-3aa3a54d3747',
      description:
        'React is as known as JavaScript library , It is usually used for building user interface’s ….',
      id: '',
    },
    {
      name: 'Some Combinations Of Vanilla JavaScript And ES6…',
      Photo: 'https://i.ibb.co/R63wMZT/es6.png',
      link:
        'https://azimuahamed.medium.com/some-combinations-of-javascript-and-es6-75871c318759',
      description:
        'Wanna know about some cool combinations of JavaScript and ES6',
      id: '',
    },
    {
      name:
        'How To Set An Element Horizontal & Vertical Align Center-CSS Layout ?',
      Photo: 'https://i.ibb.co/S5rcwfG/verticle.jpg',
      link:
        'https://azimuahamed.medium.com/how-to-set-an-element-horizontal-vertical-align-center-css-layout-d6a936b102c8',
      description:
        'Want to an element horizontal & vertical element ? This article is for you.',
      id: '',
    },
  ];
  return (
    <Container className="mt-5">
      <h1 className="mt-5 pb-4 projects-header text-center">FEATURED BLOGS</h1>
      <Row className="my-4">
        <IsEmpty
          value={BlogData}
          yes="Empty list"
          no={() => (
            <Map
              collection={BlogData}
              iteratee={(item, i) => (
                <Col
                  key={i}
                  className="my-4"
                  lg={4}
                  sm={12}
                  md={{
                    size: 4,
                    order: 1,
                  }}
                >
                  <Card
                    style={{
                      border: '1px solid #b43838',
                      borderRadius: '8px',
                      boxShadow: '2px 4px 7px gray',
                    }}
                  >
                    <CardImg
                      top
                      width="100%"
                      style={{ height: '260px' }}
                      src={item.Photo}
                      alt="Card image cap"
                    />
                    <CardBody>
                      <CardTitle>
                        <h5>{item.name}</h5>
                      </CardTitle>
                      <CardText>{item.description}</CardText>
                      <a target="_blank" rel="noreferrer" href={item.link}>
                        <Button outline color="dark">
                          &nbsp; &nbsp;
                          <strong>Read</strong>
                          &nbsp; &nbsp;
                        </Button>
                      </a>
                    </CardBody>
                  </Card>
                </Col>
              )}
            />
          )}
        />
      </Row>
    </Container>
  );
};

export default HomeBlogs;
